const getIdxStatus = function (statusId) {
  let status = ''
  if (statusId) {
    switch (statusId) {
      case 1:
        status = 'Familjeträd påbörjat'
        break
      case 2:
        status = 'Har bjudit in släktingar'
        break
      case 3:
        status = 'Har blivit inbjuden'
        break
      case 4:
        status = 'Är inbjuden'
        break
      case 5:
        status = 'Övrigt'
        break
      default:
        break
    }
  }
  return status
}

export {
  getIdxStatus
}



// WEBPACK FOOTER //
// ./src/plugins/status_idx.js